<template>
	<div class="animated fadeIn">
		<SubscriptionHeaderV2 active="about" :record_id="record_id">
			<div class="m-3">
				<tooltip label="Title" placement="right">
					<input
						name="sc_title"
						v-model="record.sc_title"
						v-validate="'required'"
						:class="{'form-control': true, 'is-invalid': errors.has('sc_title')}"
						type="text"
					/>
					<span
						v-show="errors.has('sc_title')"
						class="help is-danger invalid-feedback"
					>{{ $t(errors.first('sc_title')) }}</span>
				</tooltip>
				<tooltip label="Description" placement="right">
					<textarea
						name="sc_desc"
						v-model="record.sc_desc"
						class="form-control"
						style="resize: vertical;"
						:placeholder="$t('Description')"
						rows="3"
					></textarea>
				</tooltip>
				<tooltip label="white_domains" placement="right">
					<input-tag
						name="white_domains"
						class="form-control"
						:tags.sync="record.white_domains"
						:add-tag-on-keys="[13]"
						:placeholder="$t('white domains')"
						v-model="record.white_domains"
					></input-tag>
					<span
						v-if="errors.has('white_domains')"
						class="help is-danger invalid-feedback"
					>{{ $t(errors.first('white_domains')) }}</span>
				</tooltip>

				<div class="form-group form-actions">
					<button @click="save()" type="submit" class="btn btn-primary mb-0">{{ $t('Save') }}</button>
				</div>
			</div>
		</SubscriptionHeaderV2>
	</div>
</template>

<script>
	import axios from 'axios'
	import InputTag from 'vue-input-tag'
	import cSwitch from '../../components/Switch'
	import SubscriptionHeaderV2 from '../../components/SubscriptionHeaderV2'
	export default {
		name: 'Subscription',
		components: {
			InputTag,
			SubscriptionHeaderV2,
		},
		data() {
			return {
				record_id: 0,
				record: {
					sc_title: '',
					sc_desc: '',
					sc_command_id: 0,
					white_domains: [],
				},
			}
		},
		methods: {
			fetchSubscription(id = 0) {
				if (id) {
					this.record_id = id
					this.$root.loader = true
					axios.get('/subscription/browse/' + this.record_id).then((response) => {
						if (response.data.status) {
							this.record = response.data.data
							if (is_null(this.record.white_domains)) {
								this.record.white_domains = []
							}
						}
						this.$root.loader = false
					})
				} else {
					this.$router.push({
						path: '/subscription',
					})
				}
			},

			save() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.$root.loader = true
						axios.post('/subscription/save/' + this.record_id, this.record).then((response) => {
							if (response.data.status) {
								this.record_id = response.data.id
							}
							this.$root.loader = false
						})
					} else {
						// invalid
						this.$root.loader = false
					}
				})
			},
		},
		created() {
			this.fetchSubscription(parseInt(this.$route.params.id))
		},
	}
</script>
